import { Box, Typography } from "@mui/material";

// ICON
import AdjustIcon from '@mui/icons-material/Adjust';

// STYLING
import '../styles/ChargeSeverity.scss';

// CHARGE SEVERITY
export default function ChargeSeverity({ severity }: ChargeSeverityProps) {
    return (
        <Box className="chargeseverity" display="flex" alignItems="center" sx={{ '&:last-child': { mb: 0 }, mb: .85 }}>
            <AdjustIcon className={severity.toLowerCase()} sx={{ mr: 1 }} />
            <Typography fontFamily="Public Sans" color="white">{severity}</Typography>
        </Box>
    )
}
